export default {
  appVersion: '2.2.5',
  applicationKey: '84e1d3ec-8efe-45e1-85ef-59ee1afafe42',
  applicationSecret: '7k0l2l6Jtmofvxle51QQVR5d',
  sabBaseUrl: 'https://pkp-qa.sandboxkids.io',
  vindiBaseUrl: 'https://sandbox-app.vindi.com.br',
  vindiApiSecret: 'OHdHczFMY1lNMmEzVHd4bVc5anMzYU9JVUdHTkpWNjQyX2ZONnQxTFJqQTo=',
  appsBuilderBaseUrl: 'http://localhost:8000',
  contentTreeBaseUrl: 'https://cdn.playkidsapp.com/playkids_web_homolog',
  peanutbutterBaseUrl: 'http://localhost:8088',
  fasterAnalyticsBaseUrl: 'https://api.fstr.rocks',
  skylerBaseUrl: 'https://skyler.pkds.it',
  viacepBaseUrl: 'https://viacep.com.br',
  recaptchaKey: '6LdZ2Q0lAAAAAChJeX43D4HixmTFrGbA6Q-cw_sm',
  facebookAppId: '480872519271554',
  brazeApiKey: '408c36f6-7cf4-4c15-b9d2-90549252c9d8',
  excludedSkus: [],
  environment: 'homolog',
  bucket: 'https://assets.playkidsapp.com/offers',
  integrationACL: {
    baseUrl: 'https://playhub-hmg.kwsdk.io',
    clientId: '',
    clientSecret: ''
  }
}
